import * as authWeb from "@skilitics/auth-client/web";
import { initializeAuthClient } from "@skilitics/designer-auth";

// Synchronously sets up getAuthClient(), returns a promise for
// when any persisted auth state is refreshed if required.
// That will also be blocked on by getAuthToken(), so we don't
// need to block the rest of the app init here.
const client = initializeAuthClient(import.meta.env.REACT_APP_AUTH_CONFIG);

// workaround auth-client@2.1.0 not refreshing login tokens on restore.
// While very technically correct, this means if e.g. the refresh token
// has expired the login
void restore().catch((error) => {
  console.error("Error restoring auth state", error);
});

async function restore() {
  await client.restore(authWeb.defaultAuthStores, {
    manualChallenge: true,
  });
  if (client.stage === "none") {
    return;
  }
  if (client.loginTokens && client.loginTokens.expires < new Date()) {
    try {
      await client.refreshLoginTokens();
    } catch (error) {
      console.warn("failed to restore login tokens, logging out:", error);
      await client.logout();
      throw error;
    }
  }
  // if we got here then the login (at least) is valid
  await client.loginComplete();
}
